export default __webpack_public_path__ + "static/media/work_portfolio_about.9dfc2f83.jpg";